import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=77fbdf99"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fbdf99')) {
      api.createRecord('77fbdf99', component.options)
    } else {
      api.reload('77fbdf99', component.options)
    }
    module.hot.accept("./PostList.vue?vue&type=template&id=77fbdf99", function () {
      api.rerender('77fbdf99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/post/PostList.vue"
export default component.exports